import { IconButton } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { LuExternalLink } from "react-icons/lu"

import { Tooltip } from "@/components/ui/tooltip"

type DashboardResourceLinkProps = {
  label: string
  to: string
  params?: Record<string, string>
  search?: Record<string, unknown>
}

export function DashboardResourceLink({
  label,
  to,
  params,
  search,
}: DashboardResourceLinkProps) {
  return (
    <Tooltip content={label} openDelay={300}>
      <IconButton asChild size="xs" variant="ghost" aria-label={label}>
        <Link
          to={to}
          params={params}
          search={search}
          target="_blank"
          rel="noreferrer"
        >
          <LuExternalLink size={14} />
        </Link>
      </IconButton>
    </Tooltip>
  )
}
